import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../../utils/hooks';
import { useDatePickerDaySelectorClassNames } from './hooks/useDatePickerDaySelectorClassNames';
import { useDatePickerDaySelector } from './hooks/useDatePickerDaySelector';
import { DatePickerDaySelectorRoot, DatePickerDaySelectorWeek, DatePickerDaySelectorWeekDay, DatePickerDaySelectorDays, DatePickerDaySelectorDay, DatePickerDaySelectorDayPadding, DatePickerDaySelectorDayButton } from './style';
import { DATE_PICKER_DAY_SELECTOR_CLASS_PREFIX } from './constants';
export var DatePickerDaySelector = forwardRef(function DatePickerDaySelector(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(DATE_PICKER_DAY_SELECTOR_CLASS_PREFIX);
  var classNameComponents = useDatePickerDaySelectorClassNames(DATE_PICKER_DAY_SELECTOR_CLASS_PREFIX, className);

  var _useDatePickerDaySele = useDatePickerDaySelector(props, ref),
      rootProps = _useDatePickerDaySele.rootProps,
      weekDays = _useDatePickerDaySele.weekDays,
      dayMatrix = _useDatePickerDaySele.dayMatrix,
      getDayProps = _useDatePickerDaySele.getDayProps;

  return React.createElement(DatePickerDaySelectorRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(DatePickerDaySelectorWeek, {
    theme: theme,
    className: classNameComponents.Week
  }, weekDays.map(function (weekDay) {
    return React.createElement(DatePickerDaySelectorWeekDay, {
      key: weekDay.value,
      theme: theme,
      className: classNameComponents.WeekDay
    }, weekDay.label);
  })), React.createElement(DatePickerDaySelectorDays, {
    theme: theme,
    className: classNameComponents.Days
  }, dayMatrix.map(function (day) {
    return React.createElement(DatePickerDaySelectorDay, Object.assign({
      key: day.id
    }, day.itemProps, getDayProps(day, classNameComponents.Day), {
      theme: theme
    }), React.createElement(DatePickerDaySelectorDayPadding, Object.assign({}, day.paddingProps, {
      left: true,
      theme: theme,
      className: classNameComponents.DayPaddingLeft
    })), React.createElement(DatePickerDaySelectorDayButton, Object.assign({}, day.buttonProps, {
      theme: theme,
      className: classNameComponents.DayButton
    }), day.day), React.createElement(DatePickerDaySelectorDayPadding, Object.assign({}, day.paddingProps, {
      right: true,
      theme: theme,
      className: classNameComponents.DayPaddingRight
    })));
  })));
});
DatePickerDaySelector.defaultProps = {};